import { RestRepository } from "@/core/base/RestRepository";
import config from "@/core/config";

export const ClientsRepository = new RestRepository({
  version: "v1",
  path: "clients",
  isPublic: false,
  baseURL: config.api.url,
});
